// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { stringIsNumber } from 'validators/common/simple'
import { INVALID_NUMBER_RANGE_FORMAT } from 'errors'

// this function determines if the value is either a single int
// or it represents a numerical range.
// eg 4 or 1:7
// range must be delimited by : to be valid.
const validateNumberRange = (val, err, prop) => {
  let isValidFormat = true
  const v = val.split(':')

  // if the first value isn't  number or it doesn't have a length
  // it's invalid
  if (v[0].length && !stringIsNumber(v[0].trim()) || !v[0].trim().length) {
    isValidFormat = false
  }

  // if the second value isn't undefined and it
  // - has no length
  // - or has length but can't be parsed as an int
  // it's invalid
  if (v[1] !== undefined && (!v[1].trim().length ||
      (v[1].length && !stringIsNumber(v[1].trim())))) {
    isValidFormat = false
  }

  if (!isValidFormat) {
    err[prop] = INVALID_NUMBER_RANGE_FORMAT
  }
}

export default validateNumberRange
